export enum MediaSliderMode {
    Image = 'image',
    Video = 'video',
    Tour = 'tour',
    Floorplan = 'floorplan'
}